export const pizzaCategories = [
  {
    id: "nuove",
    it: "Le Nuove da Provare",
    en: "New Arrivals",
    items: [
      { name: "Caprina Tartufata", desc: "Pomodoro pelato condito, caprino; dopo cottura: bufala, guanciale, olio al tartufo", price: "11,50" },
      { name: "Del Cantabrico", desc: "Mozzarella, olive taggiasche; dopo cottura: valeriana, acciughe del Cantabrico, pomodorini, limone grattugiato, burrata", price: "13,50" },
      { name: "Ligure", desc: "Mozzarella; dopo cottura: pesto alla genovese, pinoli, pomodorini, stracchino, julienne di pecorino", price: "12,00" },
      { name: "Mortazza", desc: "Mozzarella di bufala in cottura; dopo cottura: stracchino, pomodorini, mortadella, granella di pistacchio, profumo di zenzero, basilico", price: "12,00" },
      { name: "Mantovana", desc: "Crema di zucca, mozzarella, gorgonzola, speck, noci", price: "11,00" },
      { name: "Stagionale", desc: "In cottura: bufala, radicchio, porcini; dopo cottura: ricotta fresca e melograno", price: "12,00" },
      { name: "Gourmet", desc: "Poca mozzarella, valeriana, cipolla caramellata, tartare di manzo, burrata, pepe rosa", price: "15,00" },
    ],
  },
  {
    id: "classiche",
    it: "Le Classiche",
    en: "The Classics",
    items: [
      { name: "Margherita", desc: "Pomodoro, mozzarella", price: "6,00" },
      { name: "Marinara", desc: "Solo pomodoro", price: "5,00" },
      { name: "Bresaola", desc: "Pomodoro, mozzarella, bresaola", price: "9,00" },
      { name: "Brie", desc: "Pomodoro, mozzarella, brie", price: "8,50" },
      { name: "Bufala", desc: "Pomodoro, solo mozzarella di bufala", price: "9,00" },
      { name: "Capricciosa", desc: "Pomodoro, mozzarella, prosciutto cotto, funghi, carciofi", price: "8,50" },
      { name: "Carbonara", desc: "Pomodoro, mozzarella, pancetta stufata, uova, grana", price: "8,00" },
      { name: "Diavola", desc: "Pomodoro, mozzarella, salamino piccante", price: "8,00" },
      { name: "Gorgonzola", desc: "Pomodoro, mozzarella, gorgonzola", price: "8,50" },
      { name: "Gorgonzola Crudo", desc: "Pomodoro, mozzarella, gorgonzola, prosciutto crudo", price: "10,50" },
      { name: "Gorgonzola Speck", desc: "Pomodoro, mozzarella, gorgonzola, speck", price: "10,00" },
      { name: "Pancetta", desc: "Pomodoro, mozzarella, pancetta stufata", price: "8,00" },
      { name: "Patatosa", desc: "Pomodoro, mozzarella, patate fritte", price: "8,00" },
      { name: "Porchetta", desc: "Pomodoro, mozzarella, porchetta", price: "8,50" },
      { name: "Prosciutto", desc: "Pomodoro, mozzarella, prosciutto cotto", price: "8,00" },
      { name: "Prosciutto e Funghi", desc: "Pomodoro, mozzarella, prosciutto cotto, funghi", price: "8,00" },
      { name: "Quattro Formaggi", desc: "Mozzarella, formaggi misti, salamino piccante, poca salsa di pomodoro al centro", price: "9,00" },
      { name: "Quattro Stagioni", desc: "Pomodoro, mozzarella, prosciutto cotto, funghi, carciofi, acciughe", price: "8,50" },
      { name: "Ricotta", desc: "Pomodoro, mozzarella, ricotta", price: "7,50" },
      { name: "Ricotta e Spinaci", desc: "Pomodoro, mozzarella, ricotta, spinaci, grana", price: "8,00" },
      { name: "San Daniele", desc: "Pomodoro, mozzarella, prosciutto crudo", price: "10,00" },
      { name: "Salsiccia", desc: "Pomodoro, mozzarella, salsiccia", price: "7,50" },
      { name: "Tirolese", desc: "Pomodoro, mozzarella, funghi, speck", price: "9,00" },
      { name: "Uova Asparagi", desc: "Pomodoro, mozzarella, uova, asparagi, grana", price: "8,00" },
      { name: "Viennese", desc: "Pomodoro, mozzarella, würstel", price: "7,50" },
    ],
  },
  {
    id: "verdure",
    it: "Alle Verdure",
    en: "Vegetable Pizzas",
    items: [
      { name: "Asparagi", desc: "Pomodoro, mozzarella, asparagi", price: "7,50" },
      { name: "Caprese", desc: "Pomodoro, mozzarella, pomodoro fresco, basilico", price: "7,50" },
      { name: "Carciofi", desc: "Pomodoro, mozzarella, carciofi", price: "8,50" },
      { name: "Chiodini", desc: "Pomodoro, mozzarella, chiodini", price: "8,00" },
      { name: "Funghi", desc: "Pomodoro, mozzarella, funghi", price: "7,00" },
      { name: "Melanzane", desc: "Pomodoro, mozzarella, melanzane grigliate", price: "7,50" },
      { name: "Misto Bosco", desc: "Pomodoro, mozzarella, champignon, porcini, chiodini", price: "10,00" },
      { name: "Olive", desc: "Pomodoro, mozzarella, olive miste denocciolate", price: "7,00" },
      { name: "Panna e Funghi", desc: "Pomodoro, mozzarella, funghi, panna", price: "7,50" },
      { name: "Peperoni Agrodolce", desc: "Pomodoro, mozzarella, peperoni agrodolce", price: "7,00" },
      { name: "Peperoni alla Piastra", desc: "Pomodoro, mozzarella, peperoni grigliati", price: "8,00" },
      { name: "Porcini", desc: "Pomodoro, mozzarella, porcini", price: "9,50" },
      { name: "Porcini e Asparagi", desc: "Pomodoro, mozzarella, porcini, asparagi", price: "9,50" },
      { name: "Primavera", desc: "Pomodoro, mozzarella, brie, rucola, pomodoro fresco, grana scaglie", price: "9,50" },
      { name: "Pugliese", desc: "Pomodoro, mozzarella, cipolla di Tropea", price: "6,50" },
      { name: "Radicchio", desc: "Pomodoro, mozzarella, radicchio grigliato", price: "8,50" },
      { name: "Rucola", desc: "Pomodoro, mozzarella, rucola", price: "7,00" },
      { name: "Verdure", desc: "Pomodoro, mozzarella, verdure miste", price: "9,50" },
      { name: "Zingara", desc: "Pomodoro, mozzarella, olive miste, peperoni, capperi, funghi", price: "8,50" },
      { name: "Zucchine", desc: "Pomodoro, mozzarella, zucchine grigliate", price: "7,50" },
    ],
  },
  {
    id: "pesce",
    it: "Con il Pesce",
    en: "Seafood Pizzas",
    items: [
      { name: "Frutti di Mare", desc: "Pomodoro, mozzarella, frutti di mare, olio agli aromi", price: "14,00" },
      { name: "Gamberetti", desc: "Pomodoro, mozzarella, gamberetti, olio agli aromi", price: "10,00" },
      { name: "Romana", desc: "Pomodoro, mozzarella, acciughe", price: "8,00" },
      { name: "Tonno", desc: "Pomodoro, mozzarella, tonno", price: "9,00" },
      { name: "Tonno e Cipolla", desc: "Pomodoro, mozzarella, tonno, cipolla di Tropea", price: "9,50" },
    ],
  },
  {
    id: "bianche",
    it: "Le Bianche",
    en: "White Pizzas",
    items: [
      { name: "Affumicata", desc: "Scamorza affumicata, zucchine e peperoni grigliati, salsiccia", price: "9,00" },
      { name: "Brie Salmone e Zucchine", desc: "Mozzarella, brie, zucchine grigliate, salmone affumicato", price: "12,00" },
      { name: "Colonnata", desc: "Mozzarella di bufala, pomodorini, olive verdi con nocciolo, lardo di Colonnata", price: "10,00" },
      { name: "Del Ciclista", desc: "Mozzarella di bufala, pomodorini, prosciutto crudo, rucola, grana scaglie", price: "12,00" },
      { name: "Del Rifugio", desc: "Mozzarella, porcini, scamorza affumicata, rosmarino, porchetta", price: "12,00" },
      { name: "Duezerounozero", desc: "Mozzarella di bufala, porcini, radicchio grigliato, emmenthal a julienne, pancetta coppata", price: "12,00" },
      { name: "Friariella", desc: "Mozzarella, salsiccia, friarielli, 'nduja, sfilacci di peperoncino", price: "10,50" },
      { name: "Gustosa", desc: "Mozzarella, olive nere con nocciolo, salsiccia, brie, cipolla di Tropea", price: "9,50" },
      { name: "Magica", desc: "Mozzarella di bufala, pomodori secchi, speck, stracchino", price: "12,00" },
      { name: "No Limit", desc: "Mozzarella di bufala, pomodorini, radicchio grigliato, lardo di Colonnata", price: "10,00" },
      { name: "Raccomandata", desc: "Mozzarella di bufala, pomodori secchi, ricotta, salamino piccante, prosciutto crudo", price: "12,50" },
      { name: "Saporita", desc: "Mozzarella, pomodori secchi, mozzarella di bufala, basilico", price: "9,00" },
      { name: "Semplice", desc: "Zucchine e radicchio grigliati, pomodorini, scaglie di grana", price: "8,50" },
      { name: "Sfiziosa", desc: "Mozzarella di bufala, zucchine grigliate, asparagi, pomodorini, salamino piccante", price: "8,50" },
    ],
  },
  {
    id: "calzoni",
    it: "Calzoni e Rotolini",
    en: "Calzoni & Rolls",
    items: [
      { name: "Calzone Classico", desc: "All'interno: mozzarella, prosciutto cotto, funghi. Sopra: salsa di pomodoro in cottura", price: "8,50" },
      { name: "Calzone alle Verdure", desc: "All'interno: mozzarella, verdure miste. Sopra: salsa di pomodoro in cottura", price: "9,50" },
      { name: "Calzone dei Casteani", desc: "All'interno: mozzarella, pomodorini, ricotta, spinaci, speck, grana. Sopra: salsa di pomodoro in cottura", price: "10,00" },
      { name: "Calzone Imperiale", desc: "Mozzarella, pomodorini, ricotta affumicata, salamino piccante, radicchio grigliato, sopra salsa di pomodoro; a fine cottura: prosciutto crudo, scaglie di grana", price: "12,00" },
      { name: "Rotolino Classico", desc: "All'interno: pomodoro, mozzarella, prosciutto cotto, pomodorini, acciughe, salamino piccante, poca cipolla Tropea. Sopra: scamorza affumicata", price: "11,50" },
      { name: "Rotolino Autunnale", desc: "All'interno: pomodoro, mozzarella, melanzane grigliate, porcini. Sopra: brie, speck, scaglie di grana", price: "12,00" },
    ],
  },
  {
    id: "speciali",
    it: "Le Speciali",
    en: "The Specials",
    items: [
      { name: "Alla Brace", desc: "Pomodoro, mozzarella, prosciutto alla brace, scamorza affumicata, pomodorini", price: "10,00" },
      { name: "An Vedi Come Balla Nando", desc: "Pomodoro, mozzarella, radicchio grigliato, pomodorini, ricotta, speck, olio agli aromi", price: "11,00" },
      { name: "Bertè", desc: "Pomodoro, mozzarella, tonno, cipolla di Tropea, uova, salamino piccante, grana", price: "10,00" },
      { name: "Boscaiola", desc: "Pomodoro, mozzarella, prosciutto cotto, chiodini, salamino piccante, piselli, grana", price: "9,00" },
      { name: "Briosa", desc: "Pomodoro, mozzarella, prosciutto cotto, brie, pomodorini, salamino piccante, melanzane grigliate", price: "10,50" },
      { name: "Bufala, Pachino, Olive Nere", desc: "Pomodoro, mozzarella di bufala, olive nere con nocciolo, pomodorini", price: "10,50" },
      { name: "Bufala, Pomodorini e Basilico", desc: "Pomodoro, mozzarella di bufala, pomodorini", price: "10,00" },
      { name: "Carlotta", desc: "Pomodoro, mozzarella, cuori di carciofo, pomodorini, rucola, stracchino, scaglie di grana", price: "12,00" },
      { name: "Ciociara", desc: "Pomodoro, mozzarella, würstel, salamino piccante, salsiccia", price: "9,50" },
      { name: "Contadina", desc: "Pomodoro, mozzarella, radicchio grigliato, salsiccia, gorgonzola", price: "10,00" },
      { name: "Cosacca", desc: "Pomodoro, mozzarella, prosciutto cotto, zucchine grigliate, uova, grana", price: "9,00" },
      { name: "Del Pizzaiolo", desc: "Pomodoro, mozzarella, tonno, würstel, salamino piccante, peperoni grigliati", price: "11,00" },
      { name: "Del Rugbista", desc: "Pomodoro, mozzarella, salsiccia, peperoni, cipolla, gorgonzola, pancetta, patate arroste", price: "13,00" },
      { name: "Dell'Anno", desc: "Pomodoro, radicchio grigliato, funghi misti, mozzarella di bufala, sopressa, scaglie di grana, olio agli aromi", price: "12,00" },
      { name: "Della Marca", desc: "Pomodoro, mozzarella di bufala, chiodini, radicchio e peperoni grigliati, porchetta trevigiana, olio agli aromi", price: "12,00" },
      { name: "Disco Volante", desc: "Pizza speciale con doppia pasta", price: "13,00" },
      { name: "Fidati", desc: "Fantasia del pizzaiolo", price: "10,00" },
      { name: "Golosa", desc: "Pomodoro, mozzarella, ricotta, spinaci, salamino piccante, pancetta stufata, grana", price: "10,50" },
      { name: "Grintosa", desc: "Pomodoro, mozzarella, cuori di carciofo, pomodorini, olive nere con nocciolo, acciughe, scamorza affumicata, grana", price: "12,00" },
      { name: "Inferno", desc: "Pomodoro, mozzarella, acciughe, olive nere denocciolate, peperoni grigliati, salamino piccante, peperoncino", price: "10,00" },
      { name: "Inglesina", desc: "Pomodoro, mozzarella di bufala, pomodorini, rucola, roast beef, scaglie di grana", price: "13,00" },
      { name: "Italiana", desc: "Pomodoro, mozzarella, zucchine grigliate, pomodorini, ricotta", price: "8,50" },
      { name: "La Fantina", desc: "Pomodoro, mozzarella, brie; dopo cottura: rucola, sfilacci di cavallo, scaglie di grana", price: "13,00" },
      { name: "Latina", desc: "Pomodoro, mozzarella, prosciutto cotto, salamino piccante, brie, olive verdi denocciolate", price: "9,50" },
      { name: "Magna e Tasi", desc: "Pomodoro, mozzarella, pomodorini, tonno, porcini, salamino piccante, cipolla di Tropea", price: "12,00" },
      { name: "Mare e Monti", desc: "Pomodoro, mozzarella, prosciutto cotto, pomodorini, porcini, gamberetti, olio agli aromi", price: "12,50" },
      { name: "Mc Donald", desc: "Pomodoro, mozzarella, würstel, patatine fritte", price: "9,50" },
      { name: "Melanzane e Gorgonzola", desc: "Pomodoro, mozzarella, melanzane grigliate, gorgonzola", price: "8,50" },
      { name: "Melanzane Peperoni Salamino", desc: "Pomodoro, mozzarella, melanzane, peperoni grigliati, salamino piccante", price: "9,00" },
      { name: "Mitica", desc: "Pomodoro, poca mozzarella, pomodorini, mozzarella di bufala, melanzane grigliate, prosciutto alla brace", price: "11,50" },
      { name: "Mundial", desc: "Pomodoro, pancetta stufata, pomodorini, zucchine grigliate, ricotta affumicata, mozzarella di bufala, grana, olio agli aromi", price: "11,50" },
      { name: "Nonno Nanni", desc: "Pomodoro, mozzarella, radicchio trevigiano crudo, stracchino, sopressa, gocce di aceto balsamico", price: "12,00" },
      { name: "Novità", desc: "Pomodoro, mozzarella, olive nere greche, cuori di carciofo, pomodori secchi, stracchino, prosciutto alla brace", price: "12,50" },
      { name: "Numero Uno", desc: "Pomodoro, prosciutto cotto, pomodorini, olive verdi con nocciolo, capperi, salamino piccante, mozzarella di bufala dopo cottura", price: "11,00" },
      { name: "Paesana", desc: "Pomodoro, mozzarella, melanzane grigliate, porcini, salamino piccante, würstel", price: "11,00" },
      { name: "Pancetta Funghi Cipolla", desc: "Pomodoro, mozzarella, pancetta stufata, funghi, cipolla Tropea", price: "9,00" },
      { name: "Panna Speck Mais", desc: "Pomodoro, mozzarella, panna, speck, mais", price: "8,50" },
      { name: "Pappoeona", desc: "Pomodoro, mozzarella di bufala, olive nere con nocciolo, pomodorini, pancetta stufata, brie, cipolla di Tropea, olio agli aromi, grana", price: "12,50" },
      { name: "Pazza", desc: "Pomodoro, mozzarella, prosciutto cotto, funghi, carciofi, würstel, salamino piccante", price: "10,00" },
      { name: "Radicchio Gorgonzola Speck", desc: "Pomodoro, mozzarella, radicchio grigliato, gorgonzola, speck", price: "11,00" },
      { name: "Rosmarì", desc: "Pomodoro, mozzarella, salamino piccante, speck in cottura, porcini, brie, rosmarino, grana", price: "11,00" },
      { name: "Rustica", desc: "Pomodoro, mozzarella, salamino piccante, acciughe, cipolla di Tropea", price: "9,50" },
      { name: "Siciliana", desc: "Pomodoro, mozzarella, olive nere denocciolate, capperi, acciughe", price: "9,50" },
      { name: "Spassosa", desc: "Pomodoro, mozzarella di bufala, pancetta stufata, porcini, mais, pomodorini, rucola", price: "11,00" },
      { name: "Speciale", desc: "Pomodoro, mozzarella, prosciutto cotto, funghi, carciofi, peperoni grigliati, würstel, salamino piccante, asparagi, uovo", price: "12,50" },
      { name: "Speck Scamorza Peperoni", desc: "Pomodoro, mozzarella, peperoni grigliati, scamorza affumicata, speck", price: "10,00" },
      { name: "Superstar", desc: "Pomodoro, mozzarella, prosciutto cotto, pomodorini, peperoni grigliati, salamino piccante, scamorza affumicata, acciughe, cipolla Tropea", price: "13,00" },
      { name: "Trevisana", desc: "Pomodoro, mozzarella, radicchio e peperoni grigliati, cipolla di Tropea", price: "9,50" },
      { name: "Vale Vale Goigo!", desc: "Pomodoro, mozzarella, porcini, salsiccia, patate fritte", price: "11,50" },
      { name: "Valtellina", desc: "Pomodoro, mozzarella, bresaola, rucola, scaglie di grana", price: "10,50" },
      { name: "Zucchine Gamberetti", desc: "Pomodoro, mozzarella, gamberetti, zucchine grigliate, olio agli aromi", price: "10,50" },
    ],
  },
];

export const extras = [
  { name: "Baby", price: "- 1,00" },
  { name: "Battuta", price: "+ 2,50" },
  { name: "Impasto Kamut / Integrale", price: "+ 1,50" },
  { name: "Maggiorata Mozzarella", price: "+ 1,50" },
  { name: "Abbondante", price: "+ 2,00" },
  { name: "Doppia Pasta", price: "+ 2,00" },
];

export const ristoranteMenu = [
  {
    id: "antipasti",
    it: "Antipasti",
    en: "Starters",
    items: [
      { name: "Tegame del pescatore", price: "18,00" },
      { name: "Delizia di mare al vapore", price: "22,00" },
      { name: "Capesante al brandy", desc: "Al pezzo", price: "4,00" },
      { name: "Insalata di mare con julienne di verdure", price: "13,00" },
    ],
  },
  {
    id: "primi",
    it: "Primi Piatti",
    en: "First Courses",
    items: [
      { name: "Spaghetti alle vongole veraci", price: "16,00" },
      { name: "Spaghetti alla scogliera", price: "18,00" },
      { name: "Paella mista (carne e pesce)", desc: "Min. 2 persone, prezzo a persona", price: "22,00" },
      { name: "Paella solo pesce", desc: "Min. 2 persone, prezzo a persona", price: "22,00" },
    ],
  },
  {
    id: "secondi",
    it: "Secondi Piatti",
    en: "Main Courses",
    items: [
      { name: "Frittura di calamari*", price: "16,00" },
      { name: "Frittura mediterranea*", price: "18,00" },
      { name: "Frittura di calamari e gamberi*", price: "17,00" },
      { name: "Grigliata di pesce", price: "25,00" },
    ],
  },
  {
    id: "carne",
    it: "Di Carne",
    en: "Meat",
    items: [
      { name: "Tagliata di Angus alle erbette e/o rucola e grana", price: "20,00" },
    ],
  },
  {
    id: "baby",
    it: "Menù Baby",
    en: "Kids Menu",
    items: [
      { name: "Pennette e/o gnocchetti al ragù", price: "6,00" },
      { name: "Cotoletta alla milanese con patate fritte", price: "8,00" },
      { name: "Würstel alla griglia con patate fritte", price: "7,00" },
      { name: "Fritto di calamari con patate fritte", price: "11,00" },
    ],
  },
  {
    id: "contorni",
    it: "Contorni",
    en: "Side Dishes",
    items: [
      { name: "Insalata mista, verdure grigliate, patate arroste", price: "4,00" },
      { name: "Patate fritte, patate rustiche", price: "4,00" },
      { name: "Olive ascolane, verdure pastellate", price: "5,00" },
    ],
  },
];

export const gelatoFlavors = [
  { name: "Fiordilatte", tag: "classico" },
  { name: "Stracciatella", tag: "classico" },
  { name: "Crema Polin", tag: "della casa" },
  { name: "Pistacchio", tag: "crema" },
  { name: "Nocciola", tag: "crema" },
  { name: "Cioccolato Fondente", tag: "crema" },
  { name: "Bacio", tag: "crema" },
  { name: "Vaniglia", tag: "crema" },
  { name: "Caffè", tag: "crema" },
  { name: "Amarena", tag: "crema" },
  { name: "Tiramisù", tag: "della casa" },
  { name: "Liquirizia", tag: "crema" },
  { name: "Limone", tag: "frutta" },
  { name: "Fragola", tag: "frutta" },
  { name: "Lampone", tag: "frutta" },
  { name: "Mango", tag: "frutta" },
  { name: "Frutti di Bosco", tag: "frutta" },
  { name: "Menta", tag: "frutta" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1571997478779-2adcbbe9ab2f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHx3b29kJTIwZmlyZWQlMjBwaXp6YSUyMGVsZWdhbnQlMjBkYXJrfGVufDB8fHx8MTc4NjA5ODkwMnww&ixlib=rb-4.1.0&q=85",
  gelato: "https://images.unsplash.com/photo-1629385744299-74b9cf013f52?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxhcnRpc2FuYWwlMjBnZWxhdG8lMjBzY29vcHxlbnwwfHx8fDE3ODYwOTg5MDJ8MA&ixlib=rb-4.1.0&q=85",
  interior: "https://images.unsplash.com/photo-1776362441386-c02107b86576?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxpdGFsaWFuJTIwcmVzdGF1cmFudCUyMGludGVyaW9yJTIwY296eXxlbnwwfHx8fDE3ODYwOTg5MDJ8MA&ixlib=rb-4.1.0&q=85",
};

export const CONTACTS = {
  phone: "+39 0422 951288",
  phoneHref: "tel:+390422951288",
  address: "Via Roma 66, 31038 Paese (TV)",
  mapsEmbed: "https://www.google.com/maps?q=Pizzeria+Polin,+Via+Roma+66,+31038+Paese+TV&output=embed",
  mapsLink: "https://www.google.com/maps/search/?api=1&query=Pizzeria+Polin+Via+Roma+66+Paese+TV",
};
